import { render, staticRenderFns } from "./EvidenciasTab.vue?vue&type=template&id=25e8dc8a&scoped=true"
import script from "./EvidenciasTab.vue?vue&type=script&lang=js"
export * from "./EvidenciasTab.vue?vue&type=script&lang=js"
import style0 from "./EvidenciasTab.vue?vue&type=style&index=0&id=25e8dc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8dc8a",
  null
  
)

export default component.exports